import { render, staticRenderFns } from "./ChzzkChattingPanel.vue?vue&type=template&id=e1627ace&scoped=true"
import script from "./ChzzkChattingPanel.vue?vue&type=script&lang=js"
export * from "./ChzzkChattingPanel.vue?vue&type=script&lang=js"
import style0 from "./ChzzkChattingPanel.css?vue&type=style&index=0&id=e1627ace&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1627ace",
  null
  
)

export default component.exports